module.exports = __webpack_public_path__ + "html/main.component.html";